module.exports = __webpack_public_path__ + "static/tanyaa-614dfb4b063d5b39f3235e2fa10a2f6a.jpg";